import * as React from 'react';
import {ShopPageContainer} from './containers';

export const ShopPage: React.FC = () => {
    return (
        <ShopPageContainer />
    );
};
